import Vue from 'vue'
import App from './App.vue'
import 'tailwindcss/tailwind.css'
import router from './router'
import store from './store'

const localUser = window.localStorage.getItem('hyy_www_user')
store.commit('SET_USER', localUser ? JSON.parse(localUser) : null)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store: store,
}).$mount('#app')
